const en_GB = {
  loading: "Loading...",
  main_page_slogan_1: "Join to our Tribe",
  main_page_slogan_2: "and explore communication jungle!",
  main_page_sign_in: "Sign In",
  main_page_or: "Or",
  main_page_create_account: "Create a profile",

  // Niebieski - Pierwsza Lista:

  blue_section_one_title: "Features and Behavior",

  blue_subsection_one_title: "Themes and Main Features",
  blue_subsection_one_description_one: "accuracy",
  blue_subsection_one_description_two: "logic",
  blue_subsection_one_description_three: "diligence",
  blue_subsection_one_description_four: "thoroughness",
  blue_subsection_one_description_five: "consistency",
  blue_subsection_one_description_six: "regularity",
  blue_subsection_one_description_seven: "asks detailed questions",
  blue_subsection_one_description_eight: "structured",

  blue_subsection_two_title: "Behavior",
  blue_subsection_two_description_one: "process and analysis oriented",
  blue_subsection_two_description_two: "introvert",

  blue_subsection_three_title: "Sometimes received as",
  blue_subsection_three_description_one: "critical",
  blue_subsection_three_description_two: "distrustful",

  // Niebieski - Druga Lista:

  blue_section_two_title: "Body language",

  blue_subsection_two_one_title: "Stance",
  blue_subsection_two_one_description_one: "stiffened",
  blue_subsection_two_one_description_two: "„closed”",

  blue_subsection_two_two_title: "Walk",
  blue_subsection_two_two_description_one: "confident",
  blue_subsection_two_two_description_two: "straight to the objective",

  blue_subsection_two_three_title: "Gestures",
  blue_subsection_two_three_description_one: "very economical and purposeful",
  blue_subsection_two_three_description_two: "little or no gesticulation",
  blue_subsection_two_three_description_three: "sparing facial expressions",
  blue_subsection_two_three_description_four: "does not show emotion",

  blue_subsection_two_four_title: "Talk Style",
  blue_subsection_two_four_description_one: "calm",
  blue_subsection_two_four_description_two: "rhythmic",
  blue_subsection_two_four_description_three: "formalny",
  blue_subsection_two_four_description_four: "voice poorly modulated",
  blue_subsection_two_four_description_five:
    "emphasises the things that are important to him",
  blue_subsection_two_four_description_six: "precise wording",

  // Niebieski - Trzecia Lista:

  blue_section_three_title: "Under stress",

  blue_subsection_three_one_title: "Purpose",
  blue_subsection_three_one_description_one: "integrity",
  blue_subsection_three_one_description_two: "rational decisions",
  blue_subsection_three_one_description_three: "accuracy",

  blue_subsection_three_two_title: "Emphasis on",
  blue_subsection_three_two_description_one: "restraint",
  blue_subsection_three_two_description_two: "analysing",
  blue_subsection_three_two_description_three: "stiffness",

  blue_subsection_three_three_title: "Fear of",
  blue_subsection_three_three_description_one: "made a mistake",
  blue_subsection_three_three_description_two: "showing strong emotions",

  // Niebieski - Czwarta Lista:

  blue_section_four_title: "Contribution to the team",

  blue_subsection_four_one_description1_one: "self-disciplined",
  blue_subsection_four_one_description2_two: "well prepared",

  // Blue - Fifth List:

  blue_section_five_title: "Communication Style",

  blue_subsection_five_one_title: "Communication method",
  blue_subsection_five_one_description_one: "direct",

  blue_subsection_five_two_title: "What messages do you receive better",
  blue_subsection_five_two_description_one: "loaded with information",
  blue_subsection_five_two_description_two: "communicated precisely and calmly",
  blue_subsection_five_two_description_three: "objective data",
  blue_subsection_five_two_description_four: "when the caller is prepared",

  blue_subsection_five_three_title: "What messages do you dislike?",
  blue_subsection_five_three_description_one: "chaotic",
  blue_subsection_five_three_description_two: "talking `about nothing` ",
  blue_subsection_five_three_description_three: "too informal and familiar",
  blue_subsection_five_three_description_four: "emotional",

  // Niebieski - Szósta Lista:

  blue_section_six_title: "Communication with others",

  blue_subsection_six_one_title:
    "How to communicate with others? Some tips for blue people:",

  blue_subsection_six_two_title: "Blue - Red",
  blue_subsection_six_two_description_one: "speak straight",
  blue_subsection_six_two_description_two: "raise the expression level",
  blue_subsection_six_two_description_three: "be on time",
  blue_subsection_six_two_description_four: "focus on the topic and purpose",
  blue_subsection_six_two_description_five: "formulate short statements",
  blue_subsection_six_two_description_six:
    "don't avoid confrontation, but don't try to dominate",
  blue_subsection_six_two_description_seven:
    "don't talk about the process, only about the results",
  blue_subsection_six_two_description_eight:
    "present a few options and leave the choice to red",
  blue_subsection_six_two_description_nine:
    "focus on profits, benefits and effects",
  blue_subsection_six_two_description_ten:
    "don't take red's opinion personally",

  blue_subsection_six_three_title: "Blue - Yellow",
  blue_subsection_six_three_description_one: "raise the expression level",
  blue_subsection_six_three_description_two:
    "spend your energy on a social conversation",
  blue_subsection_six_three_description_three: "show emotion and appreciation",
  blue_subsection_six_three_description_four: "appreciate the fun",
  blue_subsection_six_three_description_five: "talk about people and emotions",
  blue_subsection_six_three_description_six: "don't put pressure",
  blue_subsection_six_three_description_seven: "don't restrict with procedures",
  blue_subsection_six_three_description_eight:
    "try to establish a personal contact",
  blue_subsection_six_three_description_nine: "accept delays",
  blue_subsection_six_three_description_ten:
    "don't talk about too many details",

  blue_subsection_six_four_title: "Blue - Blue",
  blue_subsection_six_four_description_one: "provide lots of information",
  blue_subsection_six_four_description_two: "be prepared",

  blue_subsection_six_five_title: "Blue - Green",
  blue_subsection_six_five_description_one: "take care of comfort and safety",
  blue_subsection_six_five_description_two: "build trust",
  blue_subsection_six_five_description_three: "focus on people",
  blue_subsection_six_five_description_four: "show empathy",
  blue_subsection_six_five_description_five:
    "do not try to dominate and impose your opinion",
  blue_subsection_six_five_description_six: "keep your word",
  blue_subsection_six_five_description_seven:
    "be understanding about emotional dilemmas",

  // Zielony - Pierwsza Lista:

  green_section_one_title: "Features and Behavior",

  green_subsection_one_title: "Themes and Main Features",
  green_subsection_one_description_one: "calm",
  green_subsection_one_description_two: "courtesy",
  green_subsection_one_description_three: "dedication",
  green_subsection_one_description_four: "patience",
  green_subsection_one_description_five: "family",
  green_subsection_one_description_six: "empathy",
  green_subsection_one_description_seven: "security",
  green_subsection_one_description_eight: "traditionalism",
  green_subsection_one_description_nine: "shyness",
  green_subsection_one_description_ten: "kindness",

  green_subsection_two_title: "Behavior",
  green_subsection_two_description_one: "people and relationship oriented",
  green_subsection_two_description_two: "introvert",

  green_subsection_three_title: "Sometimes received as",
  green_subsection_three_description_one: "possessive",

  // Zielony - Druga Lista:

  green_section_two_title: "Body language",

  green_subsection_two_one_title: "Stance",
  green_subsection_two_one_description_one: "slightly stooped",
  green_subsection_two_one_description_two: "relaxed",

  green_subsection_two_two_title: "Walk",
  green_subsection_two_two_description_one: "unsure",
  green_subsection_two_two_description_two: "short step",
  green_subsection_two_two_description_three: "even pace",

  green_subsection_two_three_title: "Gestures",
  green_subsection_two_three_description_one: "slow and gentle",
  green_subsection_two_three_description_two: "economical",
  green_subsection_two_three_description_three: " `poker face` ",

  green_subsection_two_four_title: "Talk Style",
  green_subsection_two_four_description_one: "warm and soft voice",
  green_subsection_two_four_description_two: "light voice modulation",
  green_subsection_two_four_description_three: "little accents",
  green_subsection_two_four_description_four:
    "follows the thread of conversation imposed by the interlocutor out of courtesy",
  green_subsection_two_four_description_five: "listens more than talks",

  // Zielony - Trzecia Lista:

  green_section_three_title: "Under stress",

  green_subsection_three_one_title: "Purpose",
  green_subsection_three_one_description_one: "agreement",
  green_subsection_three_one_description_two: "acceptance",
  green_subsection_three_one_description_three: "calm",

  green_subsection_three_two_title: "Emphasis on",
  green_subsection_three_two_description_one: "passive resistance",
  green_subsection_three_two_description_two: "compromise",

  green_subsection_three_three_title: "Fear of",
  green_subsection_three_three_description_one: "disappointing others",
  green_subsection_three_three_description_two: "aggression",

  // Green - Fourth List:

  green_section_four_title: "Contribution to the team",

  green_subsection_four_one_description1_one: "willing to help",
  green_subsection_four_one_description2_two: "service oriented",

  // Green - Fifth List:

  green_section_five_title: "Communication Style",

  green_subsection_five_one_title: "Communication method",
  green_subsection_five_one_description_one: "intermediate",

  green_subsection_five_two_title: "What messages do you receive better",
  green_subsection_five_two_description_one: "methodical and calm",
  green_subsection_five_two_description_two: "informal",
  green_subsection_five_two_description_three:
    "taking the initiative by others - you react better to what happens than taking the initiative",
  green_subsection_five_two_description_four:
    "predictable course of the conversation",

  green_subsection_five_three_title: "What messages do you dislike?",
  green_subsection_five_three_description_one: "too official",
  green_subsection_five_three_description_two: "confidential",
  green_subsection_five_three_description_three:
    "too many options to choose from",
  green_subsection_five_three_description_four:
    "forcing to make decisions `here and now` ",

  // Zielony - Szósta Lista:

  green_section_six_title: "Communication with others",

  green_subsection_six_one_title:
    "How to communicate with others? Some tips for greens:",

  green_subsection_six_two_title: "Green - Red",
  green_subsection_six_two_description_one: "raise the expression level",
  green_subsection_six_two_description_two: "speak specifically",
  green_subsection_six_two_description_three:
    "present ready-made results as options",
  green_subsection_six_two_description_four:
    "focus on the goal, profits and benefits",
  green_subsection_six_two_description_five:
    "don't take what you hear too personally",
  green_subsection_six_two_description_six: "avoid hesitation",
  green_subsection_six_two_description_seven: "openly present your opinion",
  green_subsection_six_two_description_eight: "focus on facts, not feelings",

  green_subsection_six_three_title: "Green - Yellow",
  green_subsection_six_three_description_one: "raise the expression level",
  green_subsection_six_three_description_two: "show commitment",
  green_subsection_six_three_description_three: "show more enthusiasm",
  green_subsection_six_three_description_four: "don't focus on negative issues",
  green_subsection_six_three_description_five: "talk more",
  green_subsection_six_three_description_six:
    "focus on the broader, overall picture of the situation",

  green_subsection_six_four_title: "Green - Blue",
  green_subsection_six_four_description_one: "focus less on the feelings",
  green_subsection_six_four_description_two:
    "focus on the logical analysis of the process",
  green_subsection_six_four_description_three: "strive for objectivity",
  green_subsection_six_four_description_four: "be accurate",
  green_subsection_six_four_description_five: "refer to sources and facts",
  green_subsection_six_four_description_six:
    "don't insist on personal opinions",
  green_subsection_six_four_description_seven:
    "try to be more distant and formal",
  green_subsection_six_four_description_eight:
    "get ready for specific questions",

  green_subsection_six_five_title: "Green - Green",
  green_subsection_six_five_description_one: "talk more",
  green_subsection_six_five_description_two: "show kindness and patience",
  green_subsection_six_five_description_three: "advise",
  green_subsection_six_five_description_four:
    "try to be a `patient consultant` ",

  // Czerwony - Pierwsza Lista:

  red_section_one_title: "Features and Behavior",

  red_subsection_one_title: "Themes and Main Features",
  red_subsection_one_description_one: "immediate result",
  red_subsection_one_description_two: "action",
  red_subsection_one_description_three: "confidence",
  red_subsection_one_description_four: "directness",
  red_subsection_one_description_five: "honesty",
  red_subsection_one_description_six: "risk taking",

  red_subsection_two_title: "Behavior",
  red_subsection_two_description_one: "result oriented",
  red_subsection_two_description_two: "extrovert",

  red_subsection_three_title: "Sometimes received as",
  red_subsection_three_description_one: "impatient",
  red_subsection_three_description_two: "aggressive",

  // Red - Second List:

  red_section_two_title: "Body language",

  red_subsection_two_one_title: "Attitude",
  red_subsection_two_one_description_one: "straightened",
  red_subsection_two_one_description_two: "sometimes stiffened",

  red_subsection_two_two_title: "Walk",
  red_subsection_two_two_description_one: "fast",

  red_subsection_two_three_title: "Gestures",
  red_subsection_two_three_description_one: "strong",
  red_subsection_two_three_description_two: "fast and violent",
  red_subsection_two_three_description_three: "gestures a lot",
  red_subsection_two_three_description_four: "looks boldly in the eyes",
  red_subsection_two_three_description_five: "firm handshake",

  red_subsection_two_four_title: "The way of speaking",
  red_subsection_two_four_description_one: "loud",
  red_subsection_two_four_description_two: "rather fast",
  red_subsection_two_four_description_three: "rhythmically",
  red_subsection_two_four_description_four: "short",
  red_subsection_two_four_description_five: "precise sentences",
  red_subsection_two_four_description_six: "low modulated voice",

  // Czerwony - Trzecia Lista:

  red_section_three_title: "Under stress",

  red_subsection_three_one_title: "Purpose",
  red_subsection_three_one_description_one: "victory",
  red_subsection_three_one_description_two: "result",
  red_subsection_three_one_description_three:
    "winning is a personal achievement",

  red_subsection_three_two_title: "Emphasis on",
  red_subsection_three_two_description_one: "winning at any cost",
  red_subsection_three_two_description_two: "directness",
  red_subsection_three_two_description_three: "impatience",

  red_subsection_three_three_title: "Fear of",
  red_subsection_three_three_description_one: "using",
  red_subsection_three_three_description_two: "being perceived as weak",

  // Red - Fourth List:

  red_section_four_title: "Contribution to the team",

  red_subsection_four_one_description1_one: "works towards the goal",
  red_subsection_four_one_description2_two: "high level of activity",

  // Czerwony - Piąta Lista:

  red_section_five_title: "Communication Style",

  red_subsection_five_one_title: "Communication method",
  red_subsection_five_one_description_one: "direct",

  red_subsection_five_two_title: "What messages do you receive best",
  red_subsection_five_two_description_one: "result oriented",
  red_subsection_five_two_description_two: "short and concise",
  red_subsection_five_two_description_three: "passed confidently",
  red_subsection_five_two_description_four: "honest and direct",
  red_subsection_five_two_description_five: "no unnecessary emotions",

  red_subsection_five_three_title: "What messages do you dislike?",
  red_subsection_five_three_description_one: "chat",
  red_subsection_five_three_description_two: "assurances without coverage",
  red_subsection_five_three_description_three:
    "falling into unnecessary details",
  red_subsection_five_three_description_four:
    "multiple translations of one case",

  // Czerwony - Szósta Lista:

  red_section_six_title: "Communication with others",

  red_subsection_six_one_title:
    "How to communicate with others? Some tips for reds:",

  red_subsection_six_two_title: "Red - Red",
  red_subsection_six_two_description_one: "don't be afraid of bold ideas",
  red_subsection_six_two_description_two: "listen carefully",
  red_subsection_six_two_description_three:
    "do not promise something that you will not deliver",
  red_subsection_six_two_description_four: "don't try to dominate",

  red_subsection_six_three_title: "Red - Yellow",
  red_subsection_six_three_description_one:
    "first a casual conversation - then business",
  red_subsection_six_three_description_two: "give up formalism",
  red_subsection_six_three_description_three: "show more enthusiasm",
  red_subsection_six_three_description_four:
    "focus on human aspects and relationships",
  red_subsection_six_three_description_five: "show commitment",
  red_subsection_six_three_description_six: "don't limit your creativity",

  red_subsection_six_four_title: "Red - Blue",
  red_subsection_six_four_description_one: "slow down and lower expression",
  red_subsection_six_four_description_two: "be patient",
  red_subsection_six_four_description_three:
    "accept a large amount of information and analysis",
  red_subsection_six_four_description_four: "provide detailed answers",
  red_subsection_six_four_description_five: "appreciate the merits",
  red_subsection_six_four_description_six: "don't underestimate",
  red_subsection_six_four_description_seven: "calmly answer the questions",
  red_subsection_six_four_description_eight: "don't put pressure",
  red_subsection_six_four_description_nine:
    "give me time to think and make a decision",

  red_subsection_six_five_title: "Red - Green",
  red_subsection_six_five_description_one:
    "show concern for people and relationships",
  red_subsection_six_five_description_two: "be less direct",
  red_subsection_six_five_description_three:
    "do not dominate and do not impose your opinion",
  red_subsection_six_five_description_four: "ask questions",
  red_subsection_six_five_description_five: "but don't listen",
  red_subsection_six_five_description_six: "treat emotions as information",
  red_subsection_six_five_description_seven: "be empathetic",
  red_subsection_six_five_description_eight:
    "do not force an immediate response",

  // Żółty - Pierwsza Lista:

  yellow_section_one_title: "Features and Behavior",

  yellow_subsection_one_title: "Themes and Main Features",
  yellow_subsection_one_description_one: "trust",
  yellow_subsection_one_description_two: "optimism",
  yellow_subsection_one_description_three: "humor",
  yellow_subsection_one_description_four: "creativity",
  yellow_subsection_one_description_five: "spontaneity",
  yellow_subsection_one_description_six: "action",
  yellow_subsection_one_description_seven: "relationships",
  yellow_subsection_one_description_eight: "adventure",
  yellow_subsection_one_description_nine: "gets bored quickly",

  yellow_subsection_two_title: "Behavior",
  yellow_subsection_two_description_one: "experience-oriented",
  yellow_subsection_two_description_two: "extrovert",

  yellow_subsection_three_title: "Sometimes received as",
  yellow_subsection_three_description_one: "chaotic",

  // Żółty - Druga Lista:

  yellow_section_two_title: "Body language",

  yellow_subsection_two_one_title: "Attitude",
  yellow_subsection_two_one_description_one: "straightened",
  yellow_subsection_two_one_description_two: "relaxed",
  yellow_subsection_two_one_description_three: "free movement",

  yellow_subsection_two_two_title: "Gait",
  yellow_subsection_two_two_description_one: "free",
  yellow_subsection_two_two_description_two: "dynamic",

  yellow_subsection_two_three_title: "Gestures",
  yellow_subsection_two_three_description_one: "free",
  yellow_subsection_two_three_description_two: "rich facial expressions",
  yellow_subsection_two_three_description_three: "gestures a lot",

  yellow_subsection_two_four_title: "The way of speaking",
  yellow_subsection_two_four_description_one: "friendly",
  yellow_subsection_two_four_description_two:
    "emphasizes what he says with his whole body",
  yellow_subsection_two_four_description_three: "loud and fast",
  yellow_subsection_two_four_description_four: "rich modulation",
  yellow_subsection_two_four_description_five: "varied vocabulary",
  yellow_subsection_two_four_description_six: "often deviates from the subject",

  // Żółty - Trzecia Lista:
  yellow_section_three_title: "Under stress",

  yellow_subsection_three_one_title: "Purpose",
  yellow_subsection_three_one_description_one: "approval",
  yellow_subsection_three_one_description_two: "understanding",
  yellow_subsection_three_one_description_three: "openness",

  yellow_subsection_three_two_title: "Emphasis on",
  yellow_subsection_three_two_description_one: "passion",
  yellow_subsection_three_two_description_two: "impulsiveness",
  yellow_subsection_three_two_description_three: "honesty",

  yellow_subsection_three_three_title: "Fear of",
  yellow_subsection_three_three_description_one: "rejection",
  yellow_subsection_three_three_description_two: "lack of approval",

  // Yellow - Fourth List:

  yellow_section_four_title: "Contribution to the team",

  yellow_subsection_four_one_description1_one: "promotes ideas",
  yellow_subsection_four_one_description2_two: "achieves results by people",

  // Żółty - Piąta Lista:

  yellow_section_five_title: "Communication Style",

  yellow_subsection_five_one_title: "Communication method",
  yellow_subsection_five_one_description_one: "intermediate",

  yellow_subsection_five_two_title: "What messages do you receive better",
  yellow_subsection_five_two_description_one: "loose and free",
  yellow_subsection_five_two_description_two: "full of humor",
  yellow_subsection_five_two_description_three: "talking about everything",
  yellow_subsection_five_two_description_four: "not only about business",

  yellow_subsection_five_three_title: "What messages do you dislike?",
  yellow_subsection_five_three_description_one: "cold",
  yellow_subsection_five_three_description_two: "too official",
  yellow_subsection_five_three_description_three: "focusing on details",
  yellow_subsection_five_three_description_four: "showing impatience",
  yellow_subsection_five_three_description_five: "be bored with the topic",
  yellow_subsection_five_three_description_six: "no flexibility",
  yellow_subsection_five_three_description_seven:
    "reminding the lack of organization",

  // Żółty - Szósta Lista:

  yellow_section_six_title: "Communication with others",

  yellow_subsection_six_one_title:
    "How to communicate with others? Some tips for yellow people:",

  yellow_subsection_six_two_title: "Yellow - Red",
  yellow_subsection_six_two_description_one: "go straight to the point",
  yellow_subsection_six_two_description_two:
    "business first - then casual conversation",
  yellow_subsection_six_two_description_three: "speak specifically",
  yellow_subsection_six_two_description_four:
    "narrow down your selection options to 2-3 suggestions",
  yellow_subsection_six_two_description_five: "tone down emotions",
  yellow_subsection_six_two_description_six: "don't try to dominate",
  yellow_subsection_six_two_description_seven: "let the red make a decision",
  yellow_subsection_six_two_description_eight:
    "don't lose the thread (and don't change it)",
  yellow_subsection_six_two_description_nine:
    "present your position specifically and firmly",
  yellow_subsection_six_two_description_ten: "be punctual and focused",

  yellow_subsection_six_three_title: "Yellow - Yellow",
  yellow_subsection_six_three_description_one: "get the word out",
  yellow_subsection_six_three_description_two: "show attention",

  yellow_subsection_six_four_title: "Yellow - Blue",
  yellow_subsection_six_four_description_one: "lower expression level",
  yellow_subsection_six_four_description_two: "tone down emotions",
  yellow_subsection_six_four_description_three:
    "construct statements more linearly (introduction, development, ending)",
  yellow_subsection_six_four_description_four: "don't go to the element",
  yellow_subsection_six_four_description_five:
    "demonstrate substantive preparation",
  yellow_subsection_six_four_description_six: "try to focus on details",
  yellow_subsection_six_four_description_seven: "be patient, slow down",
  yellow_subsection_six_four_description_eight: "focus on the topic",
  yellow_subsection_six_four_description_nine: "avoid physical contact",
  yellow_subsection_six_four_description_ten:
    "do not underestimate the issues raised",

  yellow_subsection_six_five_title: "Yellow - Green",
  yellow_subsection_six_five_description_one: "listen more",
  yellow_subsection_six_five_description_two: "show support",
  yellow_subsection_six_five_description_three: "build trust",
  yellow_subsection_six_five_description_four:
    "slow down and lower the level of expression",
  yellow_subsection_six_five_description_five:
    "give me time to digest your emotions",
  yellow_subsection_six_five_description_six: "don't surprise",
  yellow_subsection_six_five_description_seven: "be honest and gentle",
  yellow_subsection_six_five_description_eight:
    "do not take advantage of your interlocutor's submission",
  yellow_subsection_six_five_description_nine:
    "calmly ask for opinions and feelings",

  // Errors:
  error_Email_Not_Exist: "No email address in database",
  error_Email_Badly_Formatted: "Wrong email address",
  error_Invalid_Password: "Wrong Password",
  error_Invalid_Length_Of_Password: "Incorrect password length",
  error_Passwords_Do_Not_Matches: "Entered passwords do not match",
  error_User_Already_In_Use: "Email address is already in use",
  error_Agreemnt_Not_Checked:
    "The regulations and privacy policy have not been accepted",
  error_Too_Many_Request:
    "The wrong password was entered too many times, please try again later or reset it",
  error_Empty_Name_Message_Box: "This field cannot be empty",
  error_Empty_Message_Box: "This field cannot be empty",

  // ListItem:
  list_title_SelectedLanguage: "Selected language",
  list_title_ApplicationLanguage: "Application language",
  list_title_AboutLoriini: "About the Loriini application",
  list_title_Agreement: "Regulations",
  list_title_PrivatePolicy: "Privacy Policy",

  // NavigationAboutColorsBox.js:
  red_title_AboutColorsBox: "Red",
  yellow_title_AboutColorsBox: "Yellow",
  blue_title_AboutColorsBox: "Blue",
  green_title_AboutColorsBox: "Green",

  //AboutColor - Quotations:
  red_quotation: "“Bring your pretty face to my axe!”",
  yellow_quotation:
    "“You like me because I’m a scoundrel. There aren’t enough scoundrels in your life.”",
  blue_quotation:
    "“I hate warriors, too narrow-minded. I’ll tell you what I do like though: a killer, a dyed-in-the-wool killer. Cold blooded, clean, methodical and thorough.”",
  green_quotation:
    "“Our differences are only skin deep, but our sames go down to the bone.”",

  // AboutLoriiniApp - Settings:
  about_LoriiniApp_title: "About the Loriini Application",
  about_LoriiniApp_slogan_one: "powered by passion",
  about_LoriiniApp_slogan_two: "made for you with <3",
  about_LoriiniApp_button: "Write to us",

  // Contact - Settings:
  contact_write_to_us_title: "Write to us!",
  contact_your_name_field: "Your name",
  contact_write_a_message_field: "Please enter a message",
  contact_send_button: "Send",
  contact_cancel_button: "Cancel",

  // ContactThankYou - Settings:
  contact_thank_you_thanks_title: "Thank you!",
  contact_thank_you_message_sent: "Message has been sent!",

  // EditProfilePage - Settings:
  editProfilePage_deleteAccount_message:
    "Click OK if you are sure you want to delete the account",
  editProfilePage_deleteAccount_else_message_one:
    "Are you sure you want to delete the account?",
  editProfilePage_deleteAccount_else_message_two:
    "Your account will be permanently deleted.",
  editProfilePage_deleteAccount_choices_no: "No",
  editProfilePage_deleteAccount_choices_yes: "Yes",
  editProfilePage_editProfile_title: "Edit Profile",
  editProfilePage_editProfile_change_password: "Change password",
  editProfilePage_editProfile_old_password: "enter old password",
  editProfilePage_editProfile_new_password: "your new password",
  editProfilePage_editProfile_repeat_new_password: "repeat new password",
  editProfilePage_editProfile_save_changes_button: "Save changes",
  editProfilePage_editProfile_remove_account_button: "Delete Account",

  editProfilePage_passwordChanged_message: "The password has been changed.",

  //EditProfilePage - saga.js:
  removeAccount_verification_message:
    "Please log in again to remove the account. Reauthorization is required to verify the removal of the account. Please log in and then go back to the settings to remove the account.",
  removeAccount_sign_in_for_remove_message_one:
    "Please log in again to remove the account.",
  removeAccount_sign_in_for_remove_message_two:
    "Re-authorization is required to verify account deletion. Log in and then go back to settings to delete the account.",
  removeAccount_choices_cancel: "Cancel",
  removeAccount_choices_okay: "Ok",
  removeAccount_accountDeleted_message:
    "Your account has been deleted. We are very sorry that you are leaving us and you will be redirected to the login page.",
  removeAccount_accountDeleted_else_message_one:
    "Your account has been deleted.",
  removeAccount_accountDeleted_else_message_two:
    "We are extremely sorry that you are leaving us, you will be redirected to the login page.",
  removeAccount_accountDeleted_text: "OK",

  // routes.js
  routes_KnowladgeManipulation: "What is manipulation?",
  routes_KnowladgeEffectiveCommunication: "About effective communication",
  routes_KnowladgeWaysOfCommunication: "Ways of communication",
  routes_KnowladgeWhatIsLoriiniTest: "Is there a Loriini test?",
  routes_KnowladgeHowInterprateResult: "How to interpret the result?",
  routes_KnowladgeColorTheory: "Color Theory",
  routes_GreenAboutColorsPage: "About the Green Parrot",
  routes_YellowAboutColorsPage: "About the Yellow Parrot",
  routes_RedAboutColorsPage: "About the Red Parrot",
  routes_BlueAboutColorsPage: "About the Blue Parrot",
  routes_AboutLoriiniApp: "About the Application",
  routes_EditProfilePage: "Edit Profile",
  routes_Start: "Back",
  routes_Privacy: "Privacy-Policy",
  routes_Cookies: "Cookies-Policy",
  routes_Agreement: "Agreement",
  routes_RegistrationForm: "RegistrationForm",
  routes_ForgotPassword: "ForgotPassword",
  routes_SendMessageReset: "SendMessageReset",
  routes_SignOut: "SignOut",
  routes_SignIn: "SignIn",
  routes_LoriiniTest: "LoriiniTest",
  routes_ContactThankYou: "Contact - Thank you",
  routes_Contact: "Contact",
  routes_ModalTest: "ModalTest",
  routes_DeleteAccount: "DeleteAccount",
  routes_Settings: "Info",
  routes_Colors: "Colors",
  routes_User: "User",
  routes_TestLoriini: "TestLoriini",
  routes_Home: "Home",
  routes_ApplicationLanguage: "Application language",

  // YellowAboutColorsPageRoute.js
  routes_YellowAboutColorsPageRoute_autorName: "Han Solo, Star Wars",
  routes_YellowAboutColorsPageRoute_title: "Yellow - Inspirational",

  // RedAboutColorsPageRoute.js
  routes_RedAboutColorsPageRoute_autorName: "Gimli, Lord of The Rings",
  routes_RedAboutColorsPageRoute_title: "Red - Dominant",

  // GreenAboutColorsPageRoute.js
  routes_GreenAboutColorsPageRoute_autorName: "Marge, The Simpsons",
  routes_GreenAboutColorsPageRoute_title: "Green - Stable",

  // BlueAboutColorsPageRoute.js
  routes_BlueAboutColorsPageRoute_autorName: "Zorg, the fifth element",
  routes_BlueAboutColorsPageRoute_title: "Blue - Analytical",

  // HomeRoute.js
  homeRoute_welcome: "Hello",
  homeRoute_textDescription: "Take the test and find out your color",
  homeRoute_button2: "Take the test",
  homeRoute_showResult: "View full result",
  homeRoute_repeatTest: "Repeat the test",
  homeRoute_howInterprateResult: "How to interpret the result?",
  homeRoute_whatIsLoriiniTest: "What is the Loriini test? - benefits",
  homeRoute_colorsTheory: "Color theory - what's going on?",

  // Header
  header_title: "Loriini Tribes",
  header_subtitle: "All shades of personality",

  // WelcomeTest
  welcomeTest_hello: "Hello",
  welcome_secondLine: "Our test is",
  welcome_thirdLine: "18 statements",
  welcome_forthLine: "relating to working life.",

  welcome_description_part1: "Select",
  welcome_description_part2: "answer",
  welcome_description_part3: "which you agree more and to what extent.",

  welcome_description2_part1: "Test solution should not take more than",
  welcome_description2_part2: "a few minutes",
  welcome_description2_part3: "- follow",
  welcome_description2_part4: "first feeling",
  welcome_description2_part5: "instead of thinking long about the answer.",

  welcome_button: "GET STARTED",

  // SliderBox
  sliderBox_dataSliderBox_1_title: "About effective communication",
  sliderBox_dataSliderBox_2_title: "Manipulation and exerting influence",
  sliderBox_dataSliderBox_3_title: "Communication methods",

  sliderBox_colorsDataBox_1: "Yellow",
  sliderBox_colorsDataBox_2: "Blue",
  sliderBox_colorsDataBox_3: "Red",
  sliderBox_colorsDataBox_4: "Green",

  sliderBox_data_title_1: "About communication",
  sliderBox_data_title_2: "Meet our colors",

  // SingleTest
  singleTest_title: "QUESTION",
  singleTest_of: "OF",
  singleTest_button: "NEXT",

  // Settings
  settings_title: "Settings",
  settings_logOut: "Log out",
  settings_editProfile: "edit profile",
  settings_slogan: "powered by passion, made for you with",

  // Results
  results_blue_red: "Blue - Red",
  results_blue_yellow: "Blue - Yellow",
  results_blue_green: "Blue - Green",
  results_red_blue: "Red - Blue",
  results_red_yellow: "Red - Yellow",
  results_red_green: "Red - Green",
  results_yellow_blue: "Yellow - Blue",
  results_yellow_red: "Yellow - Red",
  results_yellow_green: "Yellow - Green",
  results_green_red: "Green - Red",
  results_green_blue: "Green - Blue",
  results_green_yellow: "Green - Yellow",

  results_title: "Your color:",
  results_more: "Learn how to read the result",
  results_repeat: "Repeat test",
  result_no_results_1: "There`s nothing here yet.",
  result_no_results_2: "Take the test and find out your color!",
  result_do_test: "Solve the test",
  result_more_about_test: "Learn more about the test",

  // ResetSendMessage
  resetSendMessage_title: "SENT!",
  resetSendMessage_headermessage: "We have sent to the given e-mail address",
  resetSendMessage_headermessagetwo: "password reset link.",
  resetSendMessage_headertwomessage: "Check your email and log in",
  resetSendMessage_headerlastmessage: "again.",
  resetSendMessage_button_ok: "OK!",

  // Registration form
  registrationForm_title: "Registration form",
  registrationForm_e_mail: "e-mail",
  registrationForm_password: "password",
  registrationForm_repeat_password: "repeat password",
  registrationForm_agree: "I accept",
  registrationForm_agrement: "agreement",
  registartionForm_and: "and",
  registrationForm_privacy_policy: "privacy policy",
  registartionForm_create_a_profile: "Create profile",
  registartionFrom_do_you_have_a_profile: "Do you already have an account?",
  registartionForm_sign_in: "Log in",

  // login
  login_do_you_have_a_profie: "You don't have an account yet?",
  login_create_account: "Create Profile",
  login_forgot_passowrd: "I forgot my password",
  login_forgot_e_mail: "e-mail",
  login_forgot_password: "password",
  login_signin: "Log in",

  // forgot password
  forgotPassword_title: "FORGOT PASSWORD",
  forgotPassword_forgotmessage: "Enter your email address for the purpose",
  forgotPassword_forgotmessagetwo: "password reset",
  forgotPassword_email: "e-mail",
  forgotPassword_send: "Send",
  forgotPassword_askbox: "You don't have an account yet?",
  forgotPassword_create_profile: "Create profile",

  // DominateColor
  dominateColor_main: "Main Color",
  dominateColor_complementary: "Complementary Color",
  dominateColor_colors_red: "Red",
  dominateColor_colors_blue: "Blue",
  dominateColor_colors_yellow: "Yellow",
  dominateColor_colors_green: "Green",

  // FooterMenu
  footerMenu_routes0_home: "Home",
  footerMenu_routes1_your_color: "Your Color",
  footerMenu_routes2_colors: "Colors",

  // AboutColors
  aboutColors_title: "About the colors",

  //Images - same of all colors
  team_image: require("../../assets/ZESPOL.png"),
  communication_image: require("../../assets/KOMUNIKACJA.png"),

  //Images - Charts - yellow.js
  yellow_chart: require("../../assets/new_charts/yellow_normal_EN.png"),
  yellowInStress_chart: require("../../assets/new_charts/yellow_stress_EN.png"),

  //Images - Charts - blue.js
  blue_chart: require("../../assets/new_charts/blue_normal_EN.png"),
  blueInStress_chart: require("../../assets/new_charts/blue_stress_EN.png"),

  //Images - Charts - green.js
  green_chart: require("../../assets/new_charts/green_normal_EN.png"),
  greenInStress_chart: require("../../assets/new_charts/green_stress_EN.png"),

  //Images - Charts - red.js
  red_chart: require("../../assets/new_charts/red_normal_EN.png"),
  redInStress_chart: require("../../assets/new_charts/red_stress_EN.png"),
};

export default en_GB;
